import React from "react"

import moment from "moment"
import { withStyles } from "@material-ui/core"
import TextField from "@material-ui/core/TextField"
import Grid from "@material-ui/core/Grid"
import secaoStyle from "../../assets/css/layout/secaoStyle"
import Card from "../../components/Card/Card"
import CardHeader from "../../components/Card/CardHeader"
import CardBody from "../../components/Card/CardBody"
import CardFooter from "../../components/Card/CardFooter"
import Button from "../../components/CustomButtons/Button"
import { relatorioLog } from "../../util/relatoriogeral"
import {showNotification, showWaiting, hideWaiting, mapErrors} from "../../util/Constants"
import AdBlockDetect from "react-ad-block-detect"
import Dialog from "@material-ui/core/Dialog"
import Typography from "@material-ui/core/Typography"
import DialogContent from "@material-ui/core/DialogContent"

class RelatorioLog extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            data_inicial: new Date(),
            data_final: new Date(),
            errors: {}
        }
        this.handleSave = this.handleSave.bind(this)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(event) {
        let name = event.target.name
        let value = event.target.value

        this.setState(state => ({
            [name]: value,
            errors: { ...state.errors, [name]: undefined }
        }))
        
    }

    handleSave(event) {
        event.preventDefault()
        showWaiting()
        let response = (error, data) => { 
            hideWaiting()
            if (error) {
                const reader = new FileReader()
                reader.addEventListener("loadend", e => {
                    const text = e.srcElement.result
                    try {
                        let error = JSON.parse(text)
                        var ob = {
                            response: {
                                data: error
                            }
                        }
                        this.setState({
                            errors: mapErrors(ob)
                        })
                    } catch (e) {
                        showNotification(
                            "top",
                            "center",
                            `Ocorreram erros! ${error.message}`,
                            "danger"
                        )
                    }
                })
                reader.readAsText(error.response.data)
            } else {
                var url = URL.createObjectURL(data)
                let tempLink = document.createElement("a")
                tempLink.setAttribute("target", "_blank")
                tempLink.setAttribute("href", `${url}`)
                tempLink.setAttribute("style", "display:none;")
                document.body.appendChild(tempLink)
                tempLink.click()
                document.body.removeChild(tempLink)
            }
        }
        relatorioLog(
            moment(this.state.data_inicial).format("YYYY-MM-DD"), 
            moment(this.state.data_final).format("YYYY-MM-DD"),
            response)
    }
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.container}>
                <Card>
                    <CardHeader color="primary">
                        <Grid container direction="row">
                            <Grid item lg={10} xs={12}>
                                <h2 className={classes.cardTitleWhite}>
                                    Relatório de Log
                                </h2>
                            </Grid>
                        </Grid>
                    </CardHeader>
                    <CardBody>
                        <Grid container direction="row" spacing={16}>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <TextField
                                    type="date"
                                    name="data_inicial"
                                    label="Data Inicial"
                                    fullWidth
                                    error={this.state.errors.data_inicial}
                                    helperText={this.state.errors.data_inicial}
                                    onChange={this.handleChange}
                                    margin="normal"
                                    variant="outlined"
                                    defaultValue={moment(this.state.data_inicial).format("YYYY-MM-DD")}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                <TextField
                                    id="outlined-select-currency"
                                    type="date"
                                    name="data_final"
                                    label="Data Final"
                                    fullWidth
                                    error={this.state.errors.data_final}
                                    helperText={this.state.errors.data_final}
                                    onChange={this.handleChange}
                                    margin="normal"
                                    variant="outlined"
                                    defaultValue={moment(this.state.data_final).format("YYYY-MM-DD")}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                        </Grid>
                    </CardBody>
                    <CardFooter>
                        <Grid container justify="center">
                            <Grid item lg={2}>
                                <Button block color="info" round onClick={this.handleSave}>
                                    Gerar
                            </Button>
                            </Grid>
                        </Grid>
                    </CardFooter>
                </Card>

                <AdBlockDetect>
          <Dialog open={true} aria-labelledby="form-dialog-title">
            <DialogContent>
              <Grid
                container
                justify="center"
                alignItems="center"
                direction="row"
              >
                <Grid item xs={12} sm={12} md={8} lg={8}>
                  <Typography variant="h5" gutterBottom>
                    Por favor, desabilite o ADBlock para geração de relatório.
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
        </AdBlockDetect>
            </div>
        )
    }
}


export default withStyles(secaoStyle)(RelatorioLog)